export default __webpack_public_path__ + "static/dpx-logo-928cfa210d401675aa86213a8ae82442.png";